export default __webpack_public_path__ + "static/venture-enterprise-478c57be6e2c32413e179b1266a1c143.png";